import { render, staticRenderFns } from "./NewList2.vue?vue&type=template&id=095dd94e&scoped=true&"
import script from "./NewList2.vue?vue&type=script&lang=js&"
export * from "./NewList2.vue?vue&type=script&lang=js&"
import style0 from "./NewList2.vue?vue&type=style&index=0&id=095dd94e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095dd94e",
  null
  
)

export default component.exports